var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFensterUnterteilen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Icn/40px/Fenster-Unterteilen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,29 L21,31 L19,31 L19,29 L21,29 Z M10,23 L10,27 L16,27 L16,29 L10,29 C8.8954305,29 8,28.1045695 8,27 L8,23 L10,23 Z M32,23 L32,27 C32,28.1045695 31.1045695,29 30,29 L24,29 L24,27 L30,27 L30,23 L32,23 Z M21,25 L21,27 L19,27 L19,25 L21,25 Z M21,21 L21,23 L19,23 L19,21 L21,21 Z M17,19 L17,21 L15,21 L15,19 L17,19 Z M25,19 L25,21 L23,21 L23,19 L25,19 Z M29,19 L29,21 L27,21 L27,19 L29,19 Z M33,19 L33,21 L31,21 L31,19 L33,19 Z M13,19 L13,21 L11,21 L11,19 L13,19 Z M9,19 L9,21 L7,21 L7,19 L9,19 Z M21,17 L21,19 L19,19 L19,17 L21,17 Z M16,11 L16,13 L10,13 L10,17 L8,17 L8,13 C8,11.8954305 8.8954305,11 10,11 L16,11 Z M30,11 C31.1045695,11 32,11.8954305 32,13 L32,17 L30,17 L30,13 L24,13 L24,11 L30,11 Z M21,13 L21,15 L19,15 L19,13 L21,13 Z M21,9 L21,11 L19,11 L19,9 L21,9 Z",
    id: ".._.._src_svg_Icn_40px_Fenster-Unterteilen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFensterUnterteilen);
export default __webpack_public_path__ + "static/media/Fenster-Unterteilen.24a305fb61648f76b92143bc980fb5bd.svg";
export { ForwardRef as ReactComponent };